import React from 'react';
import { Page } from 'components';
import { WarehousesProvider } from './WarehousesContext';
import Warehouses from './Warehouses';


let Index = () => {
    return (
        <WarehousesProvider>
            <Page title="Warehouses">
                <Warehouses />
            </Page>
        </WarehousesProvider>
    );
}

export default Index;